import { TruckDataListing } from "../models/TruckDetailListing/truckDetailListing.model";

export const formatTruckDetails = (truck: TruckDataListing) => {
  return {
    type: truck.type,
    duration: {
      value: truck.duration?.value,
      text: truck.duration?.text,
    },
    vendor: truck.vendor,
    vendorId: truck.vendorId ?? "",
    materialName: truck.materialTruckName,
    ...(!!truck?.materialSelected && {
      materialSelected: truck.materialSelected,
    }),
    ...(!!truck?.dispatchApprovedAt && {
      dispatchApprovedAt: truck.dispatchApprovedAt,
    }),
    pickUpLatLng: {
      lng: parseFloat(truck.pickUpLatLng?.lng),
      lat: parseFloat(truck.pickUpLatLng?.lat),
    },
    dropOffLatLng: {
      lng: parseFloat(truck.dropOffLatLng?.lng),
      lat: parseFloat(truck.dropOffLatLng?.lat),
    },
    truckType: truck.truckType,
    truckTypeValues: truck.truckTypeValues,
    milesData: {
      value: truck.milesData?.value,
      text: truck.milesData?.text,
    },
    pickUpAddress: truck.pickupLocation,
    deliveryLocation: truck.deliveryLocation,
    truckingPriceType: truck.truckingPriceType,
    truckingCost: truck.truckingCost,
    assigned: truck.assigned,
    id: truck.id,
    truckingPrice: truck.truckingPrice,
    truckingCostType: truck.truckingCostType,
    truckingQuantity: truck.truckingQuantity,
    truckingQuantityUnitType: truck.truckingQuantityUnitType,
    minimumHours: truck?.minimumHours,
    pickupIsJobSite: truck?.pickupIsJobSite,
    destinationIsJobSite: truck?.destinationIsJobSite,
    locked: truck?.locked,
    isBlocked: !!truck?.isBlocked,
  };
};
